import { RouteConfig } from "vue-router";

import contractAccept from "@/views/pages/customers/contractAccept.vue";
import cooperationAccept from "@/views/pages/account/cooperationAccept.vue";


const confirmMail: Array<RouteConfig> = [
  {
    path: "/contract-invite/:id",
    name: "contract-invite",
    component: contractAccept,
    meta: {
      notRequiredAuth: true,
    },
  },
  {
    path: "/cooperation-approval/:userCompanyId",
    name: "cooperation-approval",
    component: cooperationAccept,
    meta: {
      notRequiredAuth: true,
    },
  },
];

export default confirmMail;
